<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import type { EmblaSliderApi } from "./types";

    let className: string | undefined = undefined;
    export { className as class };
    export let slidesCount: number;
    export let perPage = 3;
    export let currentIndex = 0;
    export let api: EmblaSliderApi | undefined;
    export let position: "absolute" | "static" = "static";
    export let bottom = "auto";

    let dotsCount = 0;

    $: {
        slidesCount;
        dotsCount = Math.ceil(slidesCount / perPage);
    }

    const handleDots = (index: number, event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        api?.scrollTo(index);
    };
</script>

{#if slidesCount > 1}
    <ul
        class={CN("gw-dots gw-list-reset-default-styles", className, {
            "gw-dots--absolute": position === "absolute",
        })}
        style={position === "absolute" ? `bottom: ${bottom};` : ""}
        on:click|stopPropagation
        on:keydown|stopPropagation
    >
        {#if dotsCount && dotsCount > 1}
            {#each { length: dotsCount } as _, index}
                <li class="gw-dots__dot">
                    <BaseButton
                        class={CN("gw-dots__button", {
                            "gw-dots__button--active": currentIndex === index,
                        })}
                        on:click={(event) => handleDots(index, event)}
                        aria-label="Go to slide {index + 1}"
                    >
                        <slot />
                    </BaseButton>
                </li>
            {/each}
        {/if}
    </ul>
{/if}

<style lang="postcss">
    .gw-dots {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;

        &__dot {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__button--active {
            background-color: rgba(255, 255, 255, 0.9);
            border-color: rgba(255, 255, 255, 1);
        }
    }

    /* Position variants */
    .gw-dots--absolute {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
</style>
